import { useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { BiChevronDown } from "react-icons/bi";

const SearchMultipleSelector = (props: {
    label?: string;
    hideLabel?: boolean;
    options: any;
    displayKey: string;
    onSelect: any;
    value?: string | null;
    canCreate?: boolean;
	createNew?: any;
    disabled?: boolean;
    inputSmall?: boolean;
}) => {
    const {
        label,
        options,
        displayKey,
        onSelect,
        hideLabel,
        canCreate,
		createNew,
        disabled,
        inputSmall = false,
    } = props;
    const [inputValue, setInputValue] = useState("");
    const [selected, setSelected] = useState("");
    const [open, setOpen] = useState(false);

    return (
        <div className="h-10 w-full font-medium gap-2">
            <label
                htmlFor={hideLabel ? "" : label}
                className={`
                    ${
                        inputSmall
                            ? "text-xs font-medium"
                            : "text-sm font-medium"
                    }
                    text-navy-700 dark:text-white`}
            >
                {hideLabel ? "" : label}
            </label>
            <div
                onClick={() => {
                    if (disabled) return;
                    setOpen(!open);
                }}
                className={`${
                    inputSmall && "h-[35px]"
                } flex w-full items-center justify-between rounded-xl border ${
                    disabled ? "bg-gray-100" : "bg-white bg-white/0"
                } p-3 text-sm outline-none ${
                    !selected && "text-sm text-gray-300"
                }`}
            >
                {options.filter((o: any) => o.active).length > 0
                    ? `${
                          options.filter((o: any) => o.active).length
                      } clients sélectionnés`
                    : "Sélectionner"}
                <BiChevronDown
                    size={20}
                    className={`${open && "rotate-180"}`}
                />
            </div>
            <ul
                className={`mt-2 overflow-y-auto rounded-xl bg-white ${
                    open ? "max-h-60 border" : "max-h-0"
                } `}
            >
                <div className="sticky top-0 flex items-center bg-white px-2">
                    <AiOutlineSearch size={18} className="text-gray-700" />
                    <input
                        type="text"
                        value={inputValue}
                        onChange={(e) =>
                            setInputValue(e.target.value.toLowerCase())
                        }
                        placeholder={`Recherche...`}
                        className="w-[80%] p-2 text-sm outline-none placeholder:text-gray-700"
                    />
                    {canCreate && (
                        <button
                            className="ml-10 hidden text-xs outline-none placeholder:text-gray-700 lg:block"
                            onClick={createNew}
                        >
                            Ajouter
                        </button>
                    )}
                </div>
                {options?.map((option: any, index: number) => (
                    <li
                        key={`${option?.[displayKey]}-${index}`}
                        className={`sticky p-2 text-sm hover:bg-gray-100 cursor-pointer
			  ${
                  option?.name?.toLowerCase() === selected?.toLowerCase() ||
                  option?.active
                      ? "bg-gray-100"
                      : "bg-white"
              }
			  ${
                  option?.[displayKey]?.toLowerCase().includes(inputValue)
                      ? "block"
                      : "hidden"
              }`}
                        onClick={() => {
                            if (
                                option?.[displayKey]?.toLowerCase() !==
                                selected.toLowerCase()
                            ) {
                                setSelected(option?.[displayKey]);
                                onSelect(option);
                                setInputValue("");
                            }
                        }}
                    >
                        {option?.[displayKey]}
                        <input
                            key={`${option?.[displayKey]}-checkbox`}
                            id={option?.[displayKey]}
                            type="checkbox"
                            checked={option?.active}
                            onChange={() => {}}
                            className="ml-2 w-4 h-4 text-toola-500 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        ></input>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SearchMultipleSelector;
